import staffRequestApi from 'api/staffRequest';
import { noRecord } from 'constants/constants';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedCentre } from 'store/master';

const TopCentres = () => {
  const [intakelist, setIntakelist] = useState([]);
  const router = useRouter();
  const selectedCentre = useSelector(getSelectedCentre);

  useEffect(() => {
    const fetchDashboardCount = async () => {
      try {
        let params = {
          limit: 4,
          status: 'COMPLETED',
          ...(selectedCentre && { courseCentre: selectedCentre?._id }),
        };
        const response = await staffRequestApi.getTopCentreData(params);
        setIntakelist(response);
      } catch (error) {
        handleToastError(error);
      }
    };

    fetchDashboardCount();
  }, [router?.query, selectedCentre]);


  const transformedList = intakelist.reduce((acc, item) => {
    item.centers.forEach((centre) => {
      let existing = acc.find((i) => i.name === centre.courseCentre?.[0]?.name);
      if (!existing) {
        existing = {
          name: centre.courseCentre?.[0]?.name,
          onboard: 'Onboarded',
          onboardCount: 0,
          offboard: 'Offboarded',
          offboardCount: 0,
          transferStaff: 'Active User',
          transferStaffCount: 0,
        };
        acc.push(existing);
      }

      if (item._id === 'ON_BOARDING') {
        existing.onboardCount += centre.totalRequests;
      } else if (item._id === 'OFF_BOARDING') {
        existing.offboardCount += centre.totalRequests;
      } else if (item._id === 'TRANSFER_STAFF') {
        existing.transferStaffCount += centre.totalRequests;
      }
    });

    return acc;
  }, []);

  return (
    <>
      <div className="learningpath-onboading-card">
        <section>
          <h6 className="onboard-dashboard-title mb-1 ">
            Top Centres (Onboarded & Active User & Offboarded )
          </h6>
        </section>
        {transformedList.length ? (
          <section>
            {transformedList?.map(
              (name, i) =>
                i < 4 && (
                  <>
                    <p
                      className={`${i % 2 === 0 ? 'instructor-container' : ''
                        } view-page-name mb-0 px-1`}
                      style={{ padding: '6px 0px' }}
                    >
                      <table
                        style={{
                          width: '100%',
                          tableLayout: 'fixed',
                        }}
                      >
                        <tr>
                          <td
                            style={{
                              width: '25%',
                              textAlign: 'left',
                            }}
                          >
                            <p
                              className="text-truncate m-0"
                              title={name?.name ? name?.name : '--'}
                            >
                              {name?.name ? name?.name : '--'}
                            </p>
                          </td>
                          <td
                            style={{
                              width: '25%',
                              textAlign: 'left',
                            }}
                          >
                            <p
                              className="text-truncate m-0"
                              title={name?.onboardCount + name?.onboard}
                            >
                              <span style={{ color: '#17AB70' }}>
                                {name?.onboardCount}
                              </span>{' '}
                              {name?.onboard ? name?.onboard : '--'}
                            </p>
                          </td>
                          <td
                            style={{
                              width: '25%',
                              textAlign: 'left',
                            }}
                          >
                            <p
                              className="text-truncate m-0"
                              title={
                                name?.transferStaffCount + name?.transferStaff
                              }
                            >
                              <span style={{ color: '#BB4E2C' }}>
                                {name?.transferStaffCount}
                              </span>{' '}
                              {name?.transferStaff ? name?.transferStaff : '--'}
                            </p>
                          </td>
                          <td
                            style={{
                              width: '25%',
                              textAlign: 'left',
                            }}
                          >
                            <p
                              className="text-truncate m-0"
                              title={name?.offboardCount + name?.offboard}
                            >
                              <span style={{ color: '#BB4E2C' }}>
                                {name?.offboardCount}
                              </span>{' '}
                              {name?.offboard ? name?.offboard : '--'}
                            </p>
                          </td>
                        </tr>
                      </table>
                    </p>
                  </>
                ),
            )}
          </section>
        ) : (
          <p className="view-page-name mb-0 py-50 px-1">{noRecord}</p>
        )}
      </div>
    </>
  );
};

export default TopCentres;
